import React, {Component} from 'react';
import {Col, Card, CardBody, Row, Button} from "reactstrap";
import Modal from "./Modal";
import {connect} from "react-redux";
import {getDealrooms} from "../../../store/actions";
import {Link} from "react-router-dom";
import Pagination from "rc-pagination";
import 'rc-pagination/assets/index.css';


class Dealroom extends Component {
  state = {
    modalToggle: false,
  };

  componentDidMount() {
    const {getDealrooms} = this.props;
    getDealrooms(1);
  }

  toggle = () => {
    this.setState({
      modalToggle: false
    });
  };

  modalOpen = () => {
    this.setState({modalToggle: true})
  };

  onPaginationChange = (page) => {
    const {getDealrooms} = this.props;
    getDealrooms(page);
  };

  render() {
    const {modalToggle} = this.state;
    const {dealrooms,dealroomsCount} = this.props;

    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardBody>
                <div style={{overflow: 'hidden'}}>
                  <span style={{float: "left", display: "inline"}}>
                    Dealroom
                  </span>
                  <Button
                    style={{float: "right"}}
                    onClick={this.modalOpen}
                    color="primary"
                  >
                    Add New Dealroom
                  </Button>
                </div>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                  {dealrooms && dealrooms.map((dealroom, i) => {
                    return (
                      <Link to={{
                        pathname: "/dealroom-view/" + dealroom.id,
                        state: {
                          name: dealroom.name
                        }
                      }} key={i}>{dealroom.name} </Link>
                    )
                  })}
                </div>
                {dealroomsCount > 10 &&<Pagination
                  total={dealroomsCount}
                  showLessItems
                  onChange={this.onPaginationChange}
                />}
                <Modal isOpen={modalToggle} toggle={this.toggle} {...this.props}/>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dealrooms: state.dealroom.dealrooms,
    dealroomsCount: state.dealroom.dealroomsCount,
  }
};
export default connect(mapStateToProps, {getDealrooms})(Dealroom);


// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/Dealroom.js